<!-- phone-input.component.html -->
<div class="w-full">
  @if (label) {
  <label class="block text-grey-300 font-semibold mb-2" [ngClass]="labelClass">{{ label }}</label>
  }

  <div
    class="flex items-center gap-3 w-full rounded-lg border border-[#E6E8E9] bg-white px-4 py-1 focus-within:outline-none focus-within:ring-2 focus-within:ring-primary"
    [ngClass]="inputClass">
    <div class="relative">
      <select class="appearance-none pr-6 pl-2 py-1 bg-transparent text-neutral-800 font-medium outline-none"
        [ngClass]="countryCodeClass" aria-label="Country code">
        @for (c of countryCodes; track c) {
        <option [value]="c">{{ c }}</option>
        }
      </select>
      <svg class="pointer-events-none absolute right-1 top-1/2 -translate-y-1/2 h-4 w-4 text-neutral-500"
        viewBox="0 0 20 20" fill="currentColor">
        <path
          d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 10.17l3.71-2.94a.75.75 0 1 1 .94 1.16l-4.2 3.33a.75.75 0 0 1-.94 0l-4.2-3.33a.75.75 0 0 1 .02-1.18z" />
      </svg>
    </div>

    <input [formControl]="control" type="tel" class="flex-1 bg-transparent placeholder-grey-800 outline-none"
      [placeholder]="placeholder" aria-label="Phone number" inputmode="numeric" autocomplete="tel-national" />
  </div>
  @if (control.dirty && control.invalid) {
  <p class="text-red-500">
    Phone number is invalid
  </p>
  }
</div>